/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {

    interface ITestCaseSelector {
        selected: string,
        id: string
    }

    class CreateSuiteController {
        private testSuiteId: number;
        private cases: Array<ITestCaseSelector>;
        private form;
        private formData = {
            name: "",
            description: "",
            schedule_string: "",
            scheduled: 0,
            ismobile: 0,
            test_cases: []
        };

        constructor(private formService: common.FormService) {
        }
        static $inject = ['formService'];

        private insert = () => {
            this.formData.test_cases = this.selectedCases();
            this.formService.submitForm('/suite/store',
                this.formData);
        }

          private update = () => {
            this.formData.test_cases = this.selectedCases();
            this.formService.submitForm(`/suite/${this.testSuiteId}`,
                this.formData);
        }


        private selectedCases = () => {
            var selectedCases = [];
            angular.forEach(this.cases, (c) => {
                var cs = <ITestCaseSelector>c;
                if (cs.selected === '1') {
                    selectedCases.push(cs.id);
                }
            });
            return selectedCases;
        }

    }

    angular.module("ultimateMonitoringApp").controller("createSuiteController", CreateSuiteController);
}
